import {
	getQueryParamsString,
	type OrderFilterDto,
	OrderStatus,
} from "Infrastructure/Api/Api";
import { useMarket } from "Market/Providers/CurrentMarketProvider";
import { useOrdersListMeta } from "Order/Api/Query/useOrdersListMetaQuery";
import { OrderPaths } from "Order/Routes/Routing";
import type { CardType } from "Shared/Components/Cards/TopCards";
import {
	DEFAULT_PAGE_INDEX,
	DEFAULT_PAGE_LIMIT,
} from "Shared/Hooks/useTableFilter";
import dayjs from "dayjs";
import { useNavigate } from "react-router";

export const useFilterCards = (): CardType[] => {
	const navigate = useNavigate();
	const marketId = useMarket()?.market?.id;

	const unassignedManagerFilter: OrderFilterDto = {
		unassignedUser: true,
		pageLimit: DEFAULT_PAGE_LIMIT,
		pageIndex: DEFAULT_PAGE_INDEX,
		marketId: marketId,
	};
	const startingTodayFilter: OrderFilterDto = {
		status: [OrderStatus.confirmed],
		dateStartingTo: dayjs().format("YYYY-MM-DD"),
		pageLimit: DEFAULT_PAGE_LIMIT,
		pageIndex: DEFAULT_PAGE_INDEX,
		marketId: marketId,
	};
	const claimsFilter: OrderFilterDto = {
		claimDateNextActionTo: dayjs().format("YYYY-MM-DD"),
		isHasClaim: true,
		pageLimit: DEFAULT_PAGE_LIMIT,
		pageIndex: DEFAULT_PAGE_INDEX,
		marketId: marketId,
	};
	const allocationFilter: OrderFilterDto = {
		status: [OrderStatus.confirmed],
		unassignedPartner: true,
		pageLimit: DEFAULT_PAGE_LIMIT,
		pageIndex: DEFAULT_PAGE_INDEX,
		marketId: marketId,
	};
	const pendingFilter: OrderFilterDto = {
		status: [OrderStatus.pending],
		dateNextActionTo: dayjs().format("YYYY-MM-DD"),
		pageLimit: DEFAULT_PAGE_LIMIT,
		pageIndex: DEFAULT_PAGE_INDEX,
		marketId: marketId,
	};

	const { data: unassignedManagerFilterCount } = useOrdersListMeta(
		unassignedManagerFilter,
	);
	const { data: startingTodayFilterCount } =
		useOrdersListMeta(startingTodayFilter);
	const { data: claimsFilterCount } = useOrdersListMeta(claimsFilter);
	const { data: allocationFilterCount } = useOrdersListMeta(allocationFilter);
	const { data: pendingFilterCount } = useOrdersListMeta(pendingFilter);

	return [
		{
			// icon: <LayerPlusIcon />,
			title: "No manager",
			digits: unassignedManagerFilterCount?.count
				? String(unassignedManagerFilterCount?.count)
				: "0",
			bgcolor: "primary",
			onClick: () => {
				navigate(
					`${OrderPaths.Index.path}${getQueryParamsString(unassignedManagerFilter)}`,
				);
			},
		},
		{
			// icon: <StarShootingIcon />,
			title: "Starting Today",
			digits: startingTodayFilterCount?.count
				? String(startingTodayFilterCount?.count)
				: "0",
			bgcolor: "success",
			onClick: () => {
				navigate(
					`${OrderPaths.Index.path}${getQueryParamsString(startingTodayFilter)}`,
				);
			},
		},
		{
			// icon: <ClaimsIcon />,
			title: "Claims",
			digits: claimsFilterCount?.count ? String(claimsFilterCount?.count) : "0",
			bgcolor: "error",
			onClick: () => {
				navigate(
					`${OrderPaths.Index.path}${getQueryParamsString(claimsFilter)}`,
				);
			},
		},
		{
			// icon: <CheckDoubleIcon />,
			title: "Allocation",
			digits: allocationFilterCount?.count
				? String(allocationFilterCount?.count)
				: "0",
			bgcolor: "info",
			onClick: () => {
				navigate(
					`${OrderPaths.Index.path}${getQueryParamsString(allocationFilter)}`,
				);
			},
		},
		{
			// icon: <SpinnerIcon />,
			title: "Pendings",
			digits: pendingFilterCount?.count
				? String(pendingFilterCount?.count)
				: "0",
			bgcolor: "warning",
			onClick: () => {
				navigate(
					`${OrderPaths.Index.path}${getQueryParamsString(pendingFilter)}`,
				);
			},
		},
	];
};
